import React, { useState, useEffect } from 'react';
import { Box } from '@mui/material';

function GithubContributions() {
  const [svgContent, setSvgContent] = useState('');

  useEffect(() => {
    const url = `https://github-contributions-api.kawarimidoll.deno.net/SKY-ALIN.svg?no-total=true&no-legend=true&scheme=blue`;

    fetch(url)
      .then((res) => res.text())
      .then((text) => setSvgContent(text))
      .catch((err) => console.error('Failed to fetch GitHub SVG:', err));
  }, []);

  return (
    <Box
      sx={{
        width: '100%',
        overflow: 'hidden', // Скрываем всё, что уехало влево
        display: 'flex',
        justifyContent: 'flex-end', // Прижимаем актуальные коммиты (правый край) к правой границе
      }}
    >
      {svgContent ? (
        <Box
          dangerouslySetInnerHTML={{ __html: svgContent }}
          sx={{
            flexShrink: 0, // Запрещаем картинке сплющиваться
            transform: 'translateX(12px)',
            '& svg': {
              display: 'block',
            },
          }}
        />
      ) : (
        <Box sx={{ height: 114, width: '100%' }} /> // Заглушка, чтобы карточка не прыгала при загрузке
      )}
    </Box>
  );
}

export default GithubContributions;
